import * as types from './mutation-types'

const mutation = {
  [types.USERS_GET_ALL](state, users) {
    state.users = users
  },
  [types.SET_SELECTED_USER](state, user) {
    state.selected_user = user
  },
  [types.PERMISSIONS_GET_ALL](state, permissions) {
    state.permissions = permissions
  },
  [types.ADD_USER](state, user) {
      state.users.push(user);
  },
  [types.UPDATE_USER](state, user) {
    state.users = [
      ...state.users.filter(element => element.id !== user.userID),
      user
    ]
  }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js